import GamePlay from "./components/GamePlay.vue";

export const componentsList = {
    GamePlay
}
